import { Box, Button, Container, Image, Input, Link, Text } from "@chakra-ui/react";
import { landingPageConstants } from "common/landingPageConstants";
import InstagramIcon from "common/assets/img/InstagramIcon.png";
import FacebookIcon from "common/assets/img/FacebookIcon.png";
import TwitterIcon from "common/assets/img/twitterIcon.png";
import LinkedinIcon from "common/assets/img/LinkedinIcon.png";
import ArrowRight from "common/assets/img/arrowIconFill.png";

const CallToAction = () => {
  return (
    <>
      <Container maxW="container.xl">
        <Box className="callToActionSection" id="contact">
          <Box className="newsletterBox">
            <Box className="newsletterTextBox">
              <Text className="newsletterTitle">
                {landingPageConstants.newslatterTitle}
              </Text>
              <Text className="newsletterTitleDesc">
                {landingPageConstants.newslatterDesc}
              </Text>
            </Box>
            <Box className="newsletterboxinput">
              <Input
                placeholder="Enter your email..."
                className="subscribeInput"
              />
              <Button className="newsletterBtn landingButtons">{landingPageConstants.requestDemo} <Image src={ArrowRight} height={"20px"} width={"20px"} alt="" /></Button>
            </Box>
          </Box>
          <Box className="managewebCont">
            <Text className="manageTitle">{landingPageConstants.Manage360}</Text>
            <Text className="manageDesc">
              {landingPageConstants.manageDesc}
            </Text>
          </Box>
          <Box className="footerLinkSocial">
            <Box className="socialMediaBox">
              <Link href="https://www.instagram.com/" target="blank" className="socialMediaLink">
                <Image src={InstagramIcon} height={"24px"} width={"24px"} alt="" />
              </Link>
              <Link href="https://www.facebook.com/" target="blank" className="socialMediaLink">
                <Image src={FacebookIcon} height={"24px"} width={"24px"} alt="" />
              </Link>
              <Link href="https://x.com/" target="blank" className="socialMediaLink">
                <Image src={TwitterIcon} height={"24px"} width={"24px"} alt="" />
              </Link>
              <Link href="https://in.linkedin.com/" target="blank" className="socialMediaLink">
                <Image src={LinkedinIcon} height={"24px"} width={"24px"} alt="" />
              </Link>
            </Box>
            <Box>
              <Box className="footerLinkBox">

                <Link href="#features" className="footerLink">
                  {landingPageConstants.feature}
                </Link>
                <Link href="#pricing" className="footerLink">
                  {landingPageConstants.plans}
                </Link>
                <Link href="#faq" className="footerLink">
                  {landingPageConstants.faq}
                </Link>
                <Link href="#contact" className="footerLink">
                  {landingPageConstants.contact}
                </Link>
                <Link href="#/privacyPolicy" className="footerLink">
                  {landingPageConstants.privacyPolicy}
                </Link>
              </Box>
            </Box>
          </Box>
          <Box className="copyrightContent">
            <Text>{landingPageConstants.copyright} <Link href="https://www.benthonlabs.com/" target="blank"><b>{landingPageConstants.companyName}.</b></Link></Text>
          </Box>
        </Box>
      </Container>
    </>
  );
};
export default CallToAction;
